// dependencies
import { mount } from 'svelte';
import App from './App.svelte';

// polyfills
import './utils/polyfills';

// styles
import './styles/graphic.scss';

// Clear console in development
if (import.meta.env.DEV) {
  console.clear();
}

// Mount the app using the Svelte 5 API
const app = mount(App, {
  target: document.getElementById('graphic'),
});

export default app;
